// Port of api/fuel/app/classes/insights/collection/types.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'types',
    requires: ['init'],
    insight: ['type'],
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var types = []

        var typeFilter = (filter.type !== undefined) ? filter.type : 'category'

        var table = (typeFilter === 'category') ? 'category' : 'mechanic'

        var exclude = (typeFilter === 'category') ? [1042, 1044] : []
        var limit = detail ? 100 : 5

        var baseIndex = this._data.base
        var typeIndex = []

        var excludeSQL = exclude.length ? (' AND l.' + table + '_id NOT IN (' + Util.in(exclude) + ')') : ''

        var rankedTypes = Util.queryFast('\
            SELECT \
                l.' + table + '_id AS t, \
                group_concat(DISTINCT l.game_id ORDER BY l.game_id ASC) as g, \
                COUNT(DISTINCT l.game_id) as c, \
                t.' + table + '_name AS n \
            FROM \
                game_' + table + ' l, \
                ' + table + ' t \
            WHERE \
                l.game_id IN (' + Util.in(baseIndex) + ') \
                AND \
                t.' + table + '_id = l.' + table + '_id \
                ' + excludeSQL + ' \
            GROUP BY \
                l.' + table + '_id \
            ORDER BY \
                COUNT(DISTINCT l.game_id) DESC, \
                t.' + table + '_name ASC \
            LIMIT \
                0, ' + limit + ' \
        ')

        var gameIndex = []

        for (var ri = 0; ri < rankedTypes.length; ri++) {
            var rankedType = rankedTypes[ri]

            typeIndex.push(parseInt(rankedType.t, 10))
            var gids = rankedType.g.split(',')
            for (var gi = 0; gi < gids.length; gi++) {
                if (gids[gi] !== '') gameIndex.push(gids[gi])
            }
        }

        var typeGames = Util.queryFast('\
            SELECT \
                l.' + table + '_id AS t, \
                l.game_id as g, \
                AVG(r.rating_value) AS r \
            FROM \
                game_' + table + ' l \
                LEFT JOIN \
                rating r \
                ON \
                r.game_id = l.game_id \
                AND \
                r.user_id IN (' + Util.in(userIndex) + ') \
            WHERE \
                l.game_id IN (' + Util.in(gameIndex) + ') \
                AND \
                l.' + table + '_id IN (' + Util.in(typeIndex) + ') \
            GROUP BY \
                l.' + table + '_id, \
                l.game_id \
            ORDER BY \
                AVG(r.rating_value) DESC, l.game_id ASC \
        ', null, 't', true)

        for (var ti = 0; ti < rankedTypes.length; ti++) {
            var ranked = rankedTypes[ti]

            var ratings = []

            var tGames = (typeGames[ranked.t] || []).slice(0, 3)

            for (var tgi = 0; tgi < tGames.length; tgi++) {
                var game = tGames[tgi]

                ratings.push({
                    id: parseInt(game.g, 10),
                    rating: game.r ? parseFloat(game.r) : '-'
                })

                this._references.games.push(parseInt(game.g, 10))
            }

            types.push({
                id: parseInt(ranked.t, 10),
                name: ranked.n,
                count: parseInt(ranked.c, 10),
                games: ratings
            })
        }

        return {
            types: types
        }

    }
})
